import { render, staticRenderFns } from "./ability_index.vue?vue&type=template&id=37f30de7&scoped=true"
import script from "./ability_index.vue?vue&type=script&lang=js"
export * from "./ability_index.vue?vue&type=script&lang=js"
import style0 from "./ability_index.vue?vue&type=style&index=0&id=37f30de7&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f30de7",
  null
  
)

export default component.exports